<template>
	<div class="feller" v-loading="loading" element-loading-text="数据加载中...">
		<div class="search">
			<!-- <el-button type="success">新增认证</el-button> -->
		</div>
		<div class="table">
			<el-table :data="tableData" height="700px" align="center" :header-cell-style="{background:'#f4f7fe'}">
				<el-table-column type="index" label="序号" width="80"></el-table-column>
				<el-table-column prop="Name" label="姓名/公司名"></el-table-column>
				<el-table-column prop="IDCard" label="唯一编号"></el-table-column>
				<el-table-column prop="Type" label="类型">
					<template slot-scope="scope">{{scope.row.Type ==0?'个人':'企业'}}</template>
				</el-table-column>
				<el-table-column prop="Address" label="地址"></el-table-column>
				<el-table-column prop="State" label="状态">
					<template slot-scope="scope">
						<el-tag type="warning" v-if="scope.row.State === 0">审核中</el-tag>
						<el-tag type="success" v-if="scope.row.State === 1">通过审核</el-tag>
						<el-tag type="danger" v-if="scope.row.State === 2">未通过审核</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="right">
					<template slot-scope="scope">
						<el-button @click="rowDetail(scope.row)" type="success" size="small">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-sizes="[10, 20, 50]"
				layout="sizes, prev, pager, next"
				:total="total"
			></el-pagination>
		</div>
		<!-- 详情对话框 -->
		<el-drawer title="采伐者详情" :visible.sync="detailModal" :modal="false" size="20%">
			<el-scrollbar style="height: 95%" ref="scrollbar">
				<el-form :model="detailForm" ref="detailForm" style="padding:10px">
					<el-form-item label="注册类型:" laber-width="120px">
						<span>{{ detailForm.Type==0?'个人':'企业' }}</span>
					</el-form-item>
					<el-form-item label="姓名/公司名:" laber-width="120px">
						<span>{{ detailForm.Name }}</span>
					</el-form-item>
					<el-form-item label="联系电话:" laber-width="120px">
						<span>{{ detailForm.Phone }}</span>
					</el-form-item>
					<el-form-item label="唯一编号:" laber-width="120px">
						<span>{{ detailForm.IDCard}}</span>
					</el-form-item>
					<el-form-item label="地址:" laber-width="120px">
						<span>{{ detailForm.Address }}</span>
					</el-form-item>
					<el-form-item label="状态:" laber-width="120px">
						<el-tag type="warning" v-if="detailForm.State === 0">审核中</el-tag>
						<el-tag type="success" v-if="detailForm.State === 1">通过审核</el-tag>
						<el-tag type="danger" v-if="detailForm.State === 2">未通过审核</el-tag>
					</el-form-item>
					<el-form-item label="创建时间日期:" laber-width="120px">
						<span>{{ detailForm.CreationTime }}</span>
					</el-form-item>
					<!-- <el-form-item label="身份证照(前):" laber-width="120px">
						<showImages v-if="detailForm.IDCardImageTops2&&detailForm.IDCardImageTops2.length>0" :imgs="detailForm.IDCardTops" :ids="detailForm.IDCardImageTops2"></showImages>
					</el-form-item>
					<el-form-item label="身份证照(后):" laber-width="120px">
						<showImages v-if="detailForm.IDCardImageAfters2&&detailForm.IDCardImageAfters2.length>0" :imgs="detailForm.IDCardAfters" :ids="detailForm.IDCardImageAfters2"></showImages>
					</el-form-item> -->
				</el-form>
			</el-scrollbar>
		</el-drawer>
	</div>
</template>

<script>
import { GetExamineLis, GetExamineDetails } from '@/api/userCenter2';
import showImages from '@/components/showImage'
export default {
	name: 'feller',
	data() {
		return {
			detailModal: false, //详情
			key: null, // 搜索关键字
			loading: false, // 数据是否处于加载状态
			tableData: [], // 表格数据
			detailForm: {}, //详情数据
			total: 0, // 数据总数
			currentPage: 1, // 当前页数
			pageSize: 10, // 当前查询数据个数
			isDialogVisible: false,

		};
	},
	components:{showImages},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 分页查询
		handleSizeChange(e) {
			this.pageSize = e;
			this.getList();
		},
		handleCurrentChange(e) {
			this.currentPage = e;
			this.getList();
		},
		/*获取所有数据列表 */
		getList() {
			GetExamineLis().then(res => {
				if (res.data.state) {
				let	data = JSON.parse(res.data.data);
					this.tableData = data.Lis;
					this.total = data.Count;
				} else {
					this.$message.error(data.msg);
				}
			})
		},
		/* 数据详情 */
		rowDetail(row) {
			GetExamineDetails(row.Id).then(res => {
				if (res.data.state == 1) {
					this.detailForm = JSON.parse(res.data.data);
					if(this.detailForm.IDCardImageTops2.length>0){
						let arr  = []
						this.detailForm.IDCardImageTops2.forEach(item=>{
							arr.push(this.$store.state.imgUrl + item.Id)
						})
						this.detailForm.IDCardTops = arr
					}
					if(this.detailForm.IDCardImageAfters2.length>0){
						let arr2 = []
						this.detailForm.IDCardImageAfters2.forEach(item=>{
							arr2.push(this.$store.state.imgUrl + item.Id)
						})
						this.detailForm.IDCardAfters = arr2
					}
				}
			});
			this.detailModal = true;
		}
	}
};
</script>
<style lang="less" scoped>
.feller {
	height: 100%;
	.search {
		padding: 30px;
		.el-input {
			margin-right: 30px;
			width: 500px;
		}
	}
	.table {
		padding: 0px 30px 0px 30px;
	}
	.page {
		text-align: center;
	}
	/deep/ .el-dialog__header {
		padding: 10px;
		background-color: #5bacf0;
	}
	/deep/ .el-dialog__title {
		color: #fff;
	}
	/deep/ .el-dialog__body {
		padding: 15px;
	}
	/deep/ .el-dialog__footer {
		padding: 0px 10px 10px 10px;
	}
	/deep/ .el-drawer {
		top: 60px !important;
		height: 100% !important;
	}
}
</style>
